import * as React from 'react';
import { css, SerializedStyles } from '@emotion/core';
import { DevPlanFieldAndAnswer } from './models';
import { COLORS } from '../../globalStyle/colors';


type ConditionalStyle = false | SerializedStyles;


const styles = {
  label: css`
    color: ${COLORS.DARK_GREY};
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
  `,
};


type Props = {
  item: DevPlanFieldAndAnswer;
  placeholder?: string;
  rows?: number;
  value: string;
  onClick?: () => void;
  onChangeAnswer?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disableTextArea?: boolean;
  textAreaStyle?: ConditionalStyle | (ConditionalStyle)[];
  className?: string;
}


/**
 * DevActionField: a component that renders a text-area where users can enter an answer for the provided development
 * action field
 *
 * Note that this component is not used for list fields - only fields that take an open-ended answer. See
 * `DevActionListField` for handling list fields.
 */
const DevActionField: React.FC<Props> = (
  {
    item,
    placeholder,
    rows,
    value,
    onClick,
    onChangeAnswer,
    disableTextArea,
    textAreaStyle,
    className,
  },
) => (
  <label
    key={item.question}
    onClick={onClick}
    className={className}
  >
    <span css={styles.label}>{item.question}</span>
    <textarea
      id={`${item.devActionId}-${item.devPlanFieldId}`}
      placeholder={placeholder}
      rows={rows}
      value={value}
      onChange={onChangeAnswer}
      disabled={disableTextArea}
      css={[textAreaStyle]}
    />
  </label>
);

export default DevActionField;
